import { Entity, Playground } from "@eai-toolkit-material-ui/icons";
import { FindInPage } from "@mui/icons-material";
import { Grid } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import { tracker } from "@openreplay/tracker";

import {
  API_DOCS_ROUTE,
  DATA_EXPLORER_PAGE_TITLE,
  DATA_EXPLORER_ROUTE,
  EAI_CONSOLE_HOST,
  EAI_CONSOLE_PROTOCOL,
  EAI_CONSOLE_URL,
  PRODUCT_NAME_TOOLKIT,
} from "@helpers/constants";
import { DASHBOARD_EVENTS } from "@helpers/events";

import Card from "./Card";
import Link from "./Link";
import type { CardsLayout } from "./Welcome";

const EaiCards = (props: {
  sxCard?: SxProps<Theme>;
  direction?: CardsLayout;
}) => {
  return (
    <Grid
      container
      spacing={2}
      direction={props.direction === "row" ? "row" : "column"}
      sx={{
        ...(props.direction === "column" && {
          height: "200px",
          "& > .MuiGrid-item": {
            flex: "1 1 auto",
          },
        }),
        ...(props.direction === "row" && {
          "& > .MuiGrid-item": {
            flex: "1 1 280px",
            minWidth: 0,
          },
        }),
      }}
    >
      <Grid item>
        <Card
          title={DATA_EXPLORER_PAGE_TITLE}
          sx={props.sxCard}
          icon={Entity}
          footer={
            <Link
              to={`${EAI_CONSOLE_URL}${DATA_EXPLORER_ROUTE}`}
              onClick={() =>
                tracker.event(
                  DASHBOARD_EVENTS.DATA_EXPLORER_GET_STARTED_CLICKED,
                )
              }
            >
              Get Started
            </Link>
          }
        >
          Explore your {PRODUCT_NAME_TOOLKIT} data <br /> using the Data
          Explorer
        </Card>
      </Grid>
      <Grid item>
        <Card
          title="Rest API Documentation"
          sx={props.sxCard}
          icon={FindInPage}
          footer={
            <Link
              href={`${EAI_CONSOLE_URL}${API_DOCS_ROUTE}`}
              onClick={() =>
                tracker.event(DASHBOARD_EVENTS.API_DOCS_GET_STARTED_CLICKED)
              }
            >
              Get Started
            </Link>
          }
        >
          Learn how to make requests to <br /> {PRODUCT_NAME_TOOLKIT} from your
          application code
        </Card>
      </Grid>
      <Grid item>
        <Card
          title="How To Run Jupyter Notebook"
          sx={props.sxCard}
          icon={Playground}
          footer={
            <Link
              href={`${EAI_CONSOLE_PROTOCOL}//docs.${EAI_CONSOLE_HOST}/pages/use_cases/running_jupyter.html`}
              onClick={() =>
                tracker.event(
                  DASHBOARD_EVENTS.JUPYTER_NOTEBOOK_GET_STARTED_CLICKED,
                )
              }
            >
              Get Started
            </Link>
          }
        >
          A quick recipe for running a <br /> Jupyter Notebook on{" "}
          {PRODUCT_NAME_TOOLKIT}
        </Card>
      </Grid>
    </Grid>
  );
};
export default EaiCards;
